import React, { useEffect } from 'react'
import Layout from '../components/layout'
import SEO from '../components/seo'

const RedirectToExposition = () => {
  useEffect(() => {
    window.location.replace('https://www.boconcept.com/pl-pl/exdisplay?store=0a72f580-4219-492d-ac2e-c78077399a57')
  }, [])
  return <div></div>
}

const Exposition = ({ location }) => (
  <Layout>
    <SEO
      title='Meble z ekspozycji BoConcept Trójmiasto'
      description='Wiele produktów powystawowych marki BoConcept jest dostępnych w atrakcyjnych cenach w związku ze stałą aktualizacją 
        naszej ekspozycji. O szczegóły pytaj w salonie.'
      pathname={location.pathname}
    />
    <RedirectToExposition />
  </Layout>
)

export default Exposition
